var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var FALLBACK_TIMEZONES = [
    'UTC',
    'Europe/Berlin',
    'Europe/Kyiv',
    'Europe/Moscow',
    'Asia/Dubai',
    'Asia/Karachi',
    'Asia/Dhaka',
    'Asia/Bangkok',
    'Asia/Tokyo',
    'Australia/Sydney',
    'America/New_York',
    'America/Los_Angeles'
];
var getSupportedTimeZones = function () {
    var intl = Intl;
    var timeZones = typeof intl.supportedValuesOf === 'function'
        ? intl.supportedValuesOf('timeZone')
        : __spreadArray([], FALLBACK_TIMEZONES, true);
    return timeZones.includes('UTC') ? timeZones : __spreadArray(['UTC'], timeZones, true);
};
var getTimezoneOffsetLabel = function (timeZone, date) {
    var _a;
    if (date === void 0) { date = new Date(); }
    try {
        var offsetPart = (_a = new Intl.DateTimeFormat('en-US', {
            timeZone: timeZone,
            timeZoneName: 'longOffset'
        })
            .formatToParts(date)
            .find(function (part) { return part.type === 'timeZoneName'; })) === null || _a === void 0 ? void 0 : _a.value;
        if (!offsetPart || offsetPart === 'GMT') {
            return 'UTC+00:00';
        }
        return offsetPart.replace('GMT', 'UTC');
    }
    catch (_b) {
        return 'UTC';
    }
};
var getTimezoneOffsetMinutes = function (timeZone, date) {
    var _a, _b, _c;
    if (date === void 0) { date = new Date(); }
    try {
        var formatter = new Intl.DateTimeFormat('en-US', {
            timeZone: timeZone,
            timeZoneName: 'longOffset'
        });
        var offset = (_b = (_a = formatter.formatToParts(date).find(function (part) { return part.type === 'timeZoneName'; })) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : 'GMT';
        if (offset === 'GMT')
            return 0;
        var match = offset.match(/GMT([+-])(\d{1,2})(?::(\d{2}))?/);
        if (!match)
            return 0;
        var sign = match[1] === '-' ? -1 : 1;
        var hours = Number(match[2]);
        var minutes = Number((_c = match[3]) !== null && _c !== void 0 ? _c : '0');
        return sign * (hours * 60 + minutes);
    }
    catch (_d) {
        return 0;
    }
};
export var formatTimezoneOptionName = function (timeZone) {
    return "".concat(timeZone, " (").concat(getTimezoneOffsetLabel(timeZone), ")");
};
export var getTimezoneOptions = function (selectedTimeZone) {
    var date = new Date();
    var options = getSupportedTimeZones()
        .map(function (timeZone) { return ({
        id: timeZone,
        name: formatTimezoneOptionName(timeZone),
        offsetMinutes: getTimezoneOffsetMinutes(timeZone, date)
    }); })
        .sort(function (a, b) {
        if (a.offsetMinutes !== b.offsetMinutes) {
            return a.offsetMinutes - b.offsetMinutes;
        }
        return String(a.id).localeCompare(String(b.id));
    })
        .map(function (_a) {
        var id = _a.id, name = _a.name;
        return ({ id: id, name: name });
    });
    if (selectedTimeZone &&
        !options.some(function (option) { return option.id === selectedTimeZone; })) {
        return __spreadArray([
            {
                id: selectedTimeZone,
                name: formatTimezoneOptionName(selectedTimeZone)
            }
        ], options, true);
    }
    return options;
};
export var findTimezoneOption = function (timeZone, options) {
    var _a, _b;
    if (options === void 0) { options = getTimezoneOptions(timeZone); }
    if (timeZone) {
        var match = options.find(function (option) { return option.id === timeZone; });
        if (match)
            return match;
        return {
            id: timeZone,
            name: formatTimezoneOptionName(timeZone)
        };
    }
    return ((_b = (_a = options.find(function (option) { return option.id === 'UTC'; })) !== null && _a !== void 0 ? _a : options[0]) !== null && _b !== void 0 ? _b : { id: 'UTC', name: formatTimezoneOptionName('UTC') });
};
